/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UnassignedUploadedFileIdArray } from './UnassignedUploadedFileIdArray'
export type TravelLog = {
  event_uuid: string | null
  event_id?: number | null
  id?: number
  employee_id: number | null
  distance_in_km?: number
  net_expenses_in_cent?: number
  tax_in_cent?: number
  currency?: string
  vehicle_type?: TravelLog.vehicle_type
  comment?: string
  km_reading_start?: number
  km_reading_end?: number
  license_plate?: string
  unassigned_uploaded_file_ids?: UnassignedUploadedFileIdArray
  assigned_file_ids?: Array<number>
}
export namespace TravelLog {
  export enum vehicle_type {
    PRIVATE_CAR = 'private_car',
    COMPANY_CAR = 'company_car',
    RENTAL_CAR = 'rental_car',
    TAXI = 'taxi',
    PUBLIC_TRANSPORTATION = 'public_transportation',
    AIRPLANE = 'airplane',
    TRAIN = 'train',
    OTHER = 'other',
  }
}
